// import React, { useState, forwardRef, useImperativeHandle } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { Offcanvas } from 'react-bootstrap';
// import AdminKilometerService from '../../api/services/AdminKilometerService';
// import swal from "sweetalert";

// const KilometerOffcanvas = () => {
//     const [file, setFile] = useState()
//     const [Error, setError] = useState('');
//     const [addKilometer, setAddKilometer] = useState(false);
   
//     const onFileChange = (e) => {
//         const fileReader = new FileReader()
//         fileReader.readAsDataURL(e.target.files[0])
//         fileReader.onload = () => {
//             var icon = fileReader.result
//             setFile(icon)
//         }
//     }
//     const nav = useNavigate();


//     const handleSubmit = async (event) => {
//         event.preventDefault();
//         try {
//             var userData = {
//                 title: event.target.title.value,
//                 price: event.target.price.value,
//                 description: event.target.description.value,
//                 icon: file ? file.split(',')[1] : "",
//             }
//             const data = await AdminKilometerService.store(userData).json();
//             if (data.status === true)
//                 swal("Kilometer Create Succesfully").then((willDelete) => {
//                     if (willDelete) {
//                         setAddKilometer(false)
//                         props.parentCallback();
//                     }
//                 })
//             {


//             }
//         }
//         catch (error) {
//             if (error.name === 'HTTPError') {
//                 const errorJson = await error.response.json();

//                 setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
//             }
//         }

//         nav("#");
//     }
//     return (
//         <>
//              <MainPagetitle mainTitle="Kilomter" pageTitle={'Services'} parentTitle={'Home'} />
//                 <div className="offcanvas-header">
//                     <h5 className="modal-title" id="#gridSystemModal">{props.Title}</h5>
//                     <button type="button" className="btn-close"
//                         onClick={() => setAddKilometer(false)}
//                     >
//                         <i className="fa-solid fa-xmark"></i>
//                     </button>
//                 </div>
//                 <div className="offcanvas-body">
//                     <div className="container-fluid">

//                         <form onSubmit={handleSubmit}>
//                             <div className="row">
//                                 <div className="col-xl-6 mb-3">
//                                     <label htmlFor="exampleFormControlInput1" className="form-label">Title<span className="text-danger">*</span></label>
//                                     <input type="text" name="title" className="form-control" id="exampleFormControlInput1" placeholder="" />
//                                 </div>
//                                 <div className="col-xl-6 mb-3">
//                                     <label htmlFor="exampleFormControlInput2" className="form-label"> Price <span className="text-danger">*</span></label>
//                                     <input type="number" name='price' className="form-control" id="exampleFormControlInput2" placeholder="" />
//                                 </div>

//                                 <div className="col-xl-12 mb-3">
//                                     <label className="form-label">Description<span className="text-danger">*</span></label>
//                                     <textarea rows="2" name='description' className="form-control"></textarea>
//                                 </div>
//                                 <div className="col-xl-12 mb-3">
//                                     <label htmlFor="val-number" className="form-label">Logo <span className="text-danger">*</span></label>
//                                     <img className="img-drop-area" src={file} alt='' />
//                                     <input type="file" className="form-control" name='icon' id="val-number" onChange={onFileChange} accept="image/png, image/jpeg, image/svg+xml" />
//                                 </div>
//                                 <p className='text-danger fs-12'>{Error}</p>

//                             </div>
//                             <div>
//                                 <button type="submit" className="btn btn-primary me-1">Submit</button>
//                                 <Link to={"#"} onClick={() => setAddKilometer(false)} className="btn btn-danger light ms-1">Cancel</Link>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
            
//         </>
//     );
// };

// export default KilometerOffcanvas;


import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MainPagetitle from '../../layouts/MainPagetitle';
import AdminKilometerService from '../../api/services/AdminKilometerService';
import swal from "sweetalert";
const KilometerOffcanvas = () => {
  const navigate = useNavigate();
  const [error, setError] = useState("")
  const [file, setFile] = useState()
  const [addKilometer, setAddKilometer] = useState(false);
  useEffect(() => {
    if (localStorage.getItem("admintoken")) {

    }
    else {
      navigate('/')
    }

  }, []);

  const onFileChange = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var icon = fileReader.result
      setFile(icon)
    }
  }
      const onSubmitForm = async (event) => {
        event.preventDefault();
        try {
            var userData = {
                title: event.target.title.value,
                "de_title": event.target.de_title.value,
                price: event.target.price.value,
                description: event.target.description.value,
                "de_description": event.target.de_description.value,
                icon: file ? file.split(',')[1] : "",
            }
            const data = await AdminKilometerService.store(userData).json();
            if (data.status === true)
                swal("Kilometer Create Succesfully").then((willDelete) => {
                    if (willDelete) {
                        
                        navigate("/admin/kilometer");
                    }
                })
            {


            }
        }
        catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();

                setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
            }
        }

        
    }
  return (
    <>
      <MainPagetitle mainTitle="Kilometer" pageTitle={'Kilometer'} parentTitle={'Home'} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Add Kilometer</h4>
              </div>
              <div className="card-body">
                <form className="form-valide" onSubmit={onSubmitForm}>

                  <div className="row">

                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >English Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='title' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >German Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_title' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label">Price <span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='price' id="val-number" />
                    </div>
                  
                    <div className="col-xl-12 mb-3">
                      <label className="form-label" htmlFor="val-suggestions">English Description <span className="text-danger">*</span></label>
                      <textarea rows="2" id="val-suggestions" className="form-control" name='description'></textarea>
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label className="form-label" htmlFor="val-suggestions">German Description <span className="text-danger">*</span></label>
                      <textarea rows="2" id="val-suggestions" className="form-control" name='de_description'></textarea>
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label className="form-label" htmlFor="val-suggestions">Image <span className="text-danger">*</span></label>
                      <img className="img-drop-area" src={file} alt=''  height={file ? 100 :0} width={file ? 100 :0}/>
                      <input type="file" className="form-control" name='icon' accept="image/png, image/jpeg, image/svg+xml" id="val-number" onChange={onFileChange} />
                    </div>
                    
                  </div>

                  <div>
                    <div className="col-xl-12 mb-3">
                      {error && <h5 style={{ color: 'red' }}>{error}</h5>}
                    </div>
                    <button type="submit" className="btn btn-primary me-1">Submit</button>

                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};
export default KilometerOffcanvas;